import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, MenuItem } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";

const validationSchema = Yup.object({
    companyLegalName: Yup.string().required("Company name is required"),
    gstinNumber: Yup.string()
        .matches(/^[0-9A-Z]{15}$/, "Invalid GSTIN")
        .required("GSTIN is required"),
    merchantAddress1: Yup.string().required("Address is required"),
    merchantState: Yup.string().required("State is required"),
    merchantCityName: Yup.string().required("City is required"),
    merchantDistrictName: Yup.string().required("District is required"),
    merchantPinCode: Yup.string().required("Pin Code is required"),
    merchantPhoneNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Invalid phone number")
        .required("Phone number is required"),
    merchantEmailId: Yup.string().email("Invalid email").required("Email is required"),
    termsConditionCheck: Yup.boolean().oneOf([true], "You must accept the terms and conditions")
});

const BusinessDetails = ({ initialValues, onNext, onBack }) => {
    const [states, setStates] = useState([]);

    useEffect(() => {
        const fetchStates = async () => {
            const token = sessionStorage.getItem("jwtToken");
            try {
                const response = await axios.get("https://api.ipaisa.co.in/myapp/auth/cmsData/getAllCmsState", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setStates(response.data.body.data);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onNext({ ...values, merchantState: Number(values.merchantState) })}
        >
            {({ values, errors, touched, handleChange }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Company Name"
                                name="companyLegalName"
                                value={values.companyLegalName}
                                onChange={handleChange}
                                error={Boolean(errors.companyLegalName && touched.companyLegalName)}
                                helperText={touched.companyLegalName && errors.companyLegalName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="GST Number"
                                name="gstinNumber"
                                value={values.gstinNumber}
                                onChange={handleChange}
                                error={Boolean(errors.gstinNumber && touched.gstinNumber)}
                                helperText={touched.gstinNumber && errors.gstinNumber}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Address"
                                name="merchantAddress1"
                                value={values.merchantAddress1}
                                onChange={handleChange}
                                error={Boolean(errors.merchantAddress1 && touched.merchantAddress1)}
                                helperText={touched.merchantAddress1 && errors.merchantAddress1}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label="State"
                                name="merchantState"
                                onChange={handleChange}
                                error={Boolean(errors.merchantState && touched.merchantState)}
                                helperText={touched.merchantState && errors.merchantState}
                            >
                                {states.map((state) => (
                                    <MenuItem key={state.stateId} value={state.stateId}>
                                        {state.state}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="City"
                                name="merchantCityName"
                                value={values.merchantCityName}
                                onChange={handleChange}
                                error={Boolean(errors.merchantCityName && touched.merchantCityName)}
                                helperText={touched.merchantCityName && errors.merchantCityName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="District"
                                name="merchantDistrictName"
                                value={values.merchantDistrictName}
                                onChange={handleChange}
                                error={Boolean(errors.merchantDistrictName && touched.merchantDistrictName)}
                                helperText={touched.merchantDistrictName && errors.merchantDistrictName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Pin Code"
                                name="merchantPinCode"
                                value={values.merchantPinCode}
                                onChange={handleChange}
                                error={Boolean(errors.merchantPinCode && touched.merchantPinCode)}
                                helperText={touched.merchantPinCode && errors.merchantPinCode}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Phone Number"
                                name="merchantPhoneNumber"
                                value={values.merchantPhoneNumber}
                                onChange={handleChange}
                                error={Boolean(errors.merchantPhoneNumber && touched.merchantPhoneNumber)}
                                helperText={touched.merchantPhoneNumber && errors.merchantPhoneNumber}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Email"
                                name="merchantEmailId"
                                value={values.merchantEmailId}
                                onChange={handleChange}
                                error={Boolean(errors.merchantEmailId && touched.merchantEmailId)}
                                helperText={touched.merchantEmailId && errors.merchantEmailId}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <label>
                                <input
                                    type="checkbox"
                                    name="termsConditionCheck"
                                    onChange={handleChange}
                                    checked={values.termsConditionCheck}
                                />
                                I accept the terms and conditions
                            </label>
                            {errors.termsConditionCheck && touched.termsConditionCheck && (
                                <div style={{ color: "red" }}>{errors.termsConditionCheck}</div>
                            )}
                        </Grid>
                    </Grid>
                    <Button variant="contained" color="secondary" sx={{ mt: 2, mr: 2 }} onClick={onBack}>
                        Back
                    </Button>
                    <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                        Next
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default BusinessDetails;
